import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="relative w-full bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-6 lg:px-12">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-12">
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-foreground-400 mb-2">
              Product
            </p>
            <h2 className="font-heading text-3xl md:text-4xl italic text-foreground-950">
              Categories
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
            Browse through {categories.length} curated product categories, each linked directly to the OOPBuy Spreadsheet system for structured product comparison and analysis.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          <a
            href={categories[0].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative bg-background-100 rounded-lg overflow-hidden cursor-pointer"
          >
            <div className="relative h-48 md:h-56 overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-500 group-hover:scale-105"
                style={{
                  backgroundImage: `url(https://readdy.ai/api/search-image?query=Elegant%20close%20up%20photography%20of%20a%20single%20pair%20of%20premium%20tan%20brown%20leather%20loafers%20with%20subtle%20brogue%20detailing%20placed%20on%20a%20cream%20colored%20textured%20linen%20fabric%20surface%20with%20a%20sprig%20of%20dried%20eucalyptus%20beside%20them%20soft%20diffused%20natural%20window%20lighting%20from%20the%20left%20side%20creating%20gentle%20shadows%20warm%20neutral%20tones%20editorial%20product%20photography%20aesthetic%20sophisticated%20minimalist%20composition&width=800&height=600&seq=cat-shoes-v2-june&orientation=landscape`,
                }}
              ></div>
            </div>
            <div className="p-5">
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-md mb-2">
                Popular
              </span>
              <h3 className="text-base font-semibold text-foreground-950">
                Shoes
              </h3>
              <p className="mt-1 text-xs text-foreground-500">Shop Now</p>
            </div>
          </a>

          <a
            href={categories[1].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative bg-background-100 rounded-lg overflow-hidden cursor-pointer"
          >
            <div className="relative h-48 md:h-56 overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-500 group-hover:scale-105"
                style={{
                  backgroundImage: `url(https://readdy.ai/api/search-image?query=Close%20up%20soft%20texture%20photography%20of%20a%20cozy%20oatmeal%20cream%20colored%20chunky%20knit%20sweater%20folded%20elegantly%20with%20visible%20cable%20knit%20pattern%20detail%20on%20a%20warm%20sand%20colored%20linen%20backdrop%20with%20soft%20morning%20light%20creating%20a%20gentle%20glow%20editorial%20fashion%20product%20photography%20minimalist%20aesthetic%20warm%20neutral%20tones%20serene%20composition%20with%20subtle%20shadows&width=800&height=600&seq=cat-hoodies-v2-june&orientation=landscape`,
                }}
              ></div>
            </div>
            <div className="p-5">
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-md mb-2">
                Trending
              </span>
              <h3 className="text-base font-semibold text-foreground-950">
                Hoodies/Sweaters
              </h3>
              <p className="mt-1 text-xs text-foreground-500">Shop Now</p>
            </div>
          </a>

          <a
            href={categories[2].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative bg-background-100 rounded-lg overflow-hidden cursor-pointer"
          >
            <div className="relative h-48 md:h-56 overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-500 group-hover:scale-105"
                style={{
                  backgroundImage: `url(https://readdy.ai/api/search-image?query=Minimalist%20flat%20lay%20product%20photography%20of%20a%20premium%20heavyweight%20cotton%20t-shirt%20in%20warm%20terracotta%20rust%20color%20folded%20neatly%20with%20visible%20garment%20texture%20on%20a%20cream%20white%20linen%20surface%20a%20single%20dried%20palm%20leaf%20placed%20diagonally%20beside%20it%20soft%20natural%20window%20light%20creating%20subtle%20shadows%20editorial%20style%20warm%20earth%20tones%20clean%20sophisticated%20composition&width=800&height=600&seq=cat-tshirts-v2-june&orientation=landscape`,
                }}
              ></div>
            </div>
            <div className="p-5">
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-md mb-2">
                Essential
              </span>
              <h3 className="text-base font-semibold text-foreground-950">
                T-Shirts
              </h3>
              <p className="mt-1 text-xs text-foreground-500">Shop Now</p>
            </div>
          </a>

          <a
            href={categories[3].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative bg-background-100 rounded-lg overflow-hidden cursor-pointer"
          >
            <div className="relative h-48 md:h-56 overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-500 group-hover:scale-105"
                style={{
                  backgroundImage: `url(https://readdy.ai/api/search-image?query=Editorial%20product%20photography%20of%20a%20stylish%20olive%20green%20lightweight%20utility%20jacket%20with%20multiple%20pockets%20draped%20casually%20over%20a%20vintage%20wooden%20chair%20on%20a%20warm%20cream%20colored%20wall%20background%20soft%20natural%20lighting%20from%20a%20nearby%20window%20creating%20gentle%20highlight%20and%20shadow%20patterns%20sophisticated%20minimalist%20aesthetic%20with%20warm%20earthy%20tones%20clean%20composition&width=800&height=600&seq=cat-jackets-v2-june&orientation=landscape`,
                }}
              ></div>
            </div>
            <div className="p-5">
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-md mb-2">
                Outerwear
              </span>
              <h3 className="text-base font-semibold text-foreground-950">
                Jackets
              </h3>
              <p className="mt-1 text-xs text-foreground-500">Shop Now</p>
            </div>
          </a>

          <a
            href={categories[4].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative bg-background-100 rounded-lg overflow-hidden cursor-pointer"
          >
            <div className="relative h-48 md:h-56 overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-500 group-hover:scale-105"
                style={{
                  backgroundImage: `url(https://readdy.ai/api/search-image?query=Elegant%20flat%20lay%20photography%20of%20tailored%20charcoal%20grey%20wide%20leg%20trousers%20with%20a%20subtle%20pinstripe%20pattern%20folded%20neatly%20beside%20a%20thin%20brown%20leather%20belt%20coiled%20in%20a%20circular%20shape%20on%20a%20warm%20oatmeal%20colored%20textured%20fabric%20surface%20soft%20natural%20window%20light%20creating%20delicate%20shadow%20details%20sophisticated%20minimalist%20fashion%20editorial%20style%20warm%20neutral%20palette&width=800&height=600&seq=cat-pants-v2-june&orientation=landscape`,
                }}
              ></div>
            </div>
            <div className="p-5">
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-md mb-2">
                Bottoms
              </span>
              <h3 className="text-base font-semibold text-foreground-950">
                Pants/Shorts
              </h3>
              <p className="mt-1 text-xs text-foreground-500">Shop Now</p>
            </div>
          </a>

          <a
            href={categories[5].url}
            target="_blank"
            rel="noopener nofollow"
            className="group relative bg-background-100 rounded-lg overflow-hidden cursor-pointer"
          >
            <div className="relative h-48 md:h-56 overflow-hidden">
              <div
                className="absolute inset-0 bg-cover bg-center bg-no-repeat transition-transform duration-500 group-hover:scale-105"
                style={{
                  backgroundImage: `url(https://readdy.ai/api/search-image?query=Close%20up%20product%20photography%20of%20a%20premium%20woven%20straw%20fedora%20hat%20with%20a%20subtle%20brown%20leather%20band%20placed%20on%20a%20light%20cream%20colored%20linen%20surface%20beside%20a%20pair%20of%20vintage%20round%20sunglasses%20soft%20natural%20window%20lighting%20from%20above%20creating%20a%20gentle%20halo%20effect%20warm%20neutral%20tones%20editorial%20fashion%20aesthetic%20sophisticated%20minimalist%20composition%20with%20subtle%20texture%20details&width=800&height=600&seq=cat-headwear-v2-june&orientation=landscape`,
                }}
              ></div>
            </div>
            <div className="p-5">
              <span className="inline-block px-3 py-1 bg-accent-100 text-accent-800 text-xs font-medium rounded-md mb-2">
                Accessories
              </span>
              <h3 className="text-base font-semibold text-foreground-950">
                Headwear
              </h3>
              <p className="mt-1 text-xs text-foreground-500">Shop Now</p>
            </div>
          </a>
        </div>
      </div>
    </section>
  );
}